const wowApp = require('angular').module('wowApp.common');

wowApp.filter('wowCurrency', ['currencyFilter', require('./wow-currency')]);
wowApp.filter('wowCurrencyFull', ['wowCurrencyFilter', require('./wow-currencyfull')]);
wowApp.filter('wowCurrencyCents', ['wowCurrencyFilter', require('./wow-currency-cents')]);
wowApp.filter('wowMaskCardNumber', [require('./wow-mask-card-number.filter')]);
wowApp.filter('sanitize', ['$sce', require('./wow-sanitize')]);
wowApp.filter('hyphenate', [require('./wow-hyphenate-name')]);
wowApp.filter('usernamelimiter', [require('./wow-username-limiter')]);
wowApp.filter('wowLoyaltyPoints', ['Settings', require('./wow-loyalty-points')]);
wowApp.filter('wowTrim', [require('./wow-trim')]);
wowApp.filter('wowPackagingPriceLabel', ['$filter', 'Settings', require('./wow-packaging-price-label')]);



// WEBPACK FOOTER //
// ./src/common/filters/index.js